import { UpToThreeActions } from '@e3dc-react/shell/Elements/Dialog/ActionDialog/types'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

/** Dialog Actions for the 'Add Device' dialogs */
export const useDialogActionsPositioned = (
  primaryName: string,
  onPrimaryAction: () => void,
  isPrimaryDisabled: boolean,
  onSecondaryAction: () => void
): UpToThreeActions => {
  const { t } = useCustomTranslation()
  return [
    {
      position: '3',
      name: t('common.cancel'),
      onClick: onSecondaryAction,
      style: 'secondary',
    },
    {
      position: '4',
      name: primaryName,
      onClick: onPrimaryAction,
      style: 'primary',
      disabled: isPrimaryDisabled,
    },
  ]
}
